<template>
  <div class="learnhome">
    <!-- 面包屑 -->
    <div class="Breadcrumb">
      <img
        @click="$router.replace('/Layout/Home')"
        src="~@img/icon/ui_home_page_0.png"
        alt
      />
      <a @click="$router.replace('/Layout/Home')">首页 &nbsp;/ &nbsp;</a>
      <a v-if="titletype == 0" @click="$router.push('/Layout/learnmodel')"
        >学习模式 &nbsp;/ &nbsp;</a
      >
      <a v-if="titletype == 1" @click="$router.push('/Layout/videorack')"
        >视频库 &nbsp;/ &nbsp;</a
      >
      <a class="active">更多</a>
    </div>
    <div class="learnhome_scroll">
      <div class="title_box">
        <span></span>
        <img src="@img/background/learn_text.png" alt="" />
      </div>
      <div class="main_box">
        <!-- 右边区域 -->
        <div class="main_r">
          <div class="main_r_title" v-if="titletype == 0">立定跳远动作解析</div>
          <div class="main_r_subtitle" v-if="titletype == 0">
            学习立定跳远标准动竹与动作解析
          </div>
          <div class="list_box">
            <div class="item_title">{{ detaiinfo.name }}</div>
            <div class="item_list">
              <div
                v-for="(item, index) in detaiinfo.videoAlls"
                :key="index"
                class="item_list_item"
                @click="getDetail(item.videoId, type, item.name)"
              >
                <div class="item_list_item_img">
                  <img :src="item.cover" alt="" />
                </div>
                <div class="item_list_item_title">
                  <img src="@img/icon/ui_video.png" alt="" />{{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      type: 0,
      titletype: 0,
      detaiinfo: {},
    };
  },
  mounted() {
    this.title = this.$route.query.title;
    this.type = this.$route.query.type;
    this.titletype = this.$route.query.titletype;
    this.titletype == 0
      ? (this.detaiinfo = sessionStorage.getItem("learninfo")
          ? JSON.parse(sessionStorage.getItem("learninfo"))
          : this.detaiinfo)
      : (this.detaiinfo = sessionStorage.getItem("info")
          ? JSON.parse(sessionStorage.getItem("info"))
          : this.detaiinfo);
  },
  methods: {
    // 训练详情
    getDetail(videoId, type,title) {
      this.$router.push({
        path:
          this.titletype == 0
            ? "actiondetail"
            : "/Layout/videorack/videodetail",
        query: { videoId: videoId, type: type, title: title },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import url("~@styles/common.less");
.learnhome {
  .learnhome_scroll {
    height: 100%;
    padding: 47px 106px;
  }
  .title_box {
    display: flex;
    align-items: center;
    height: 48px;
    span {
      width: 6px;
      height: 100%;
      background: #ffa216;
      border-radius: 1px;
    }
    img {
      margin-left: 16px;
      width: 465px;
      height: 100%;
    }
  }
  .main_box {
    margin: 31px 68px 0;
    .main_r {
      padding: 18px 17px;
      background: #ffffff;
      border: 1px solid #c0c0c0;
      opacity: 1;
      border-radius: 5px;
      .main_r_title {
        color: #ffa216;
        font-size: 25px;
        font-weight: bold;
        line-height: 33px;
      }
      .main_r_subtitle {
        padding: 5px 0 0;
        color: #313131;
        font-size: 20px;
        font-weight: 400;
        line-height: 19px;
      }
      .list_box {
        .item_title {
          padding: 18px 0 0;
          font-size: 23px;
          font-weight: bold;
          line-height: 30px;
          color: #313131;
        }
        .item_list {
          padding: 16px 0 0;
          display: flex;
          flex-wrap: wrap;
          .item_list_item {
            cursor: pointer;
            margin-bottom: 30px;
            .item_list_item_img {
              width: 280px;
              height: 157px;
              border-radius: 5px;
              img {
                width: 100%;
                height: 100%;
                border-radius: 5px;
                object-fit:cover;
                vertical-align: top;
              }
            }
            .item_list_item_title {
              padding: 12px 0 0;
              display: flex;
              align-items: center;
              color: #313131;
              font-size: 20px;
              font-weight: 400;
              line-height: 19px;
              img {
                margin-right: 3px;
                width: 24px;
                height: 24px;
              }
            }
          }
          .item_list_item:not(:nth-child(5n)) {
            margin-right: calc(6.5% / 3);
          }
        }
      }
    }
  }
}
</style>